import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateDepartment } from '../actions/setFilters';
import {
    withStyles,
    Radio,
    FormControl,
    RadioGroup,
    FormControlLabel,
    makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles({
    radio: {
        color: 'var(--white)',
        textTransform: 'capitalize',
        '& span': {
            fontWeight: '600',
            fontFamily: 'Open Sans',
        },
    },
});

const GoldRadio = withStyles({
    root: {
        color: 'var(--gold)',
        '&$checked': {
            color: 'var(--gold)',
        },
        padding: '.2rem .5rem',
    },
    checked: {},
})((props) => <Radio {...props} />);

const DepartmentSelector = (props) => {
    const classes = useStyles();

    const department = useSelector((state) => state.filters.department);

    const dispatch = useDispatch();
    const handleChangeDepartment = (event) => {
        dispatch(updateDepartment(event.target.value));
    };
    return (
        <>
            {!department && (
                <p>Please choose a department to view more filter options:</p>
            )}
            <FormControl>
                <RadioGroup
                    aria-label="department"
                    value={department}
                    onChange={handleChangeDepartment}
                >
                    <FormControlLabel
                        value="wine"
                        control={<GoldRadio />}
                        label="wine"
                        className={classes.radio}
                    />
                    <FormControlLabel
                        value="beer"
                        control={<GoldRadio />}
                        label="beer"
                        className={classes.radio}
                    />
                    <FormControlLabel
                        value="spirits"
                        control={<GoldRadio />}
                        label="spirits"
                        className={classes.radio}
                    />
                    <FormControlLabel
                        value={''}
                        control={<GoldRadio />}
                        label="all"
                        className={classes.radio}
                    />
                </RadioGroup>
            </FormControl>
        </>
    );
};

export default DepartmentSelector;
